import React from 'react';
import TextRenderer from 'src/app/components/commonComponents/TextRenderer';
import { ReportFieldType } from 'src/shared/types/src';

type ReportFieldPropTypes = {
    data: ReportFieldType[]
}

const ReportFields: React.FC<ReportFieldPropTypes> = ({ data = [] }) => {
    return (
        <div className="mx-n-20 pd-x-20 pd-b-15 border-top border-gray border-t-w-6">
            {data.map((fields, index) => {
                return (
                    <>
                    {
                        fields?.visible ? 
                        <div className='form-group mg-t-15'>
                            <div className='fs-12 fw-semibold text-black'>{fields?.label}</div>
                            <div className="fs-12 text-black mg-t-5"><TextRenderer text={fields?.value || ''} /></div>
                        </div>
                        : null
                    }
                    </>
                )
            })}
        </div>
    )
};

export default ReportFields;